import { render } from "./ModalOverlay.vue?vue&type=template&id=4adfab78&scoped=true"
import script from "./ModalOverlay.vue?vue&type=script&lang=js"
export * from "./ModalOverlay.vue?vue&type=script&lang=js"

import "./ModalOverlay.vue?vue&type=style&index=0&id=4adfab78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4adfab78"]])

export default __exports__